// @module CCAWBannerCarousel.CCAWBannerCarousel.CCAWBannerCarousel.View
define("CCAWBannerCarousel.CCAWBannerCarousel.CCAWBannerCarousel.View", [
    "ccawbannercarousel_ccawbannercarousel_ccawbannercarousel.tpl",
    "Utils",
    "Backbone",
    "underscore",
], function (
    ccawbannercarousel_ccawbannercarousel_ccawbannercarousel_tpl,
    Utils,
    Backbone,
    _
) {
    "use strict";

    // Default config values — must match CCAWBannerCarousel.json schema defaults
    var DEFAULTS = {
        autoplay: true,
        autoplayDelay: 5000,
        loop: true,
        navigation: true
    };

    // @class CCAWBannerCarousel.CCAWBannerCarousel.CCAWBannerCarousel.View @extends Backbone.View
    return Backbone.View.extend({
        template: ccawbannercarousel_ccawbannercarousel_ccawbannercarousel_tpl,

        /**
         * Initialize the view with configuration from CCAWBannerCarouselConfig.
         *
         * Config namespace (CCAWBannerCarouselConfig) provides:
         *   - banners        {Array}   Banner items sublist
         *   - autoplay       {boolean} Enable autoplay              (default: true)
         *   - autoplayDelay  {integer} Delay between slides in ms   (default: 5000)
         *   - loop           {boolean} Enable loop mode             (default: true)
         *   - navigation     {boolean} Show prev/next buttons       (default: true)
         *
         * @param {Object} options
         * @param {Object} options.container - The DI container
         */
        initialize: function initialize(options) {
            this.container = options.container;
            var env = options.container.getComponent("Environment");

            // Read config — namespace matches JSON property prefix
            var config = env.getConfig("CCAWBannerCarouselConfig") || {};

            // Banners sublist (repeating rows)
            this.banners = config.banners || [];

            // Carousel options with defaults fallback
            this.carouselOptions = {
                autoplay: typeof config.autoplay === "boolean" ? config.autoplay : DEFAULTS.autoplay,
                autoplayDelay: typeof config.autoplayDelay === "number" ? config.autoplayDelay : DEFAULTS.autoplayDelay,
                loop: typeof config.loop === "boolean" ? config.loop : DEFAULTS.loop,
                navigation: typeof config.navigation === "boolean" ? config.navigation : DEFAULTS.navigation
            };

            // Initialize Swiper after render
            this.on("afterViewRender", this.initSwiper, this);
        },

        events: {},
        bindings: {},
        childViews: {},

        /**
         * Build template context
         * @return {Object} Context data for the template
         */
        getContext: function getContext() {
            var deviceType = Utils.getDeviceType();
            var processedBanners = [];

            if (this.banners && this.banners.length > 0) {
                processedBanners = _.map(this.banners, function (banner) {
                    var imageUrl = banner.image;

                    if (deviceType === "phone" && banner.imageMobile) {
                        imageUrl = banner.imageMobile;
                    } else if (deviceType === "tablet" && banner.imageTablet) {
                        imageUrl = banner.imageTablet;
                    }

                    return {
                        image: imageUrl,
                        altText: banner.altText || "Canada Custom Autoworks",
                        linkUrl: banner.linkUrl || "",
                        isExternalLink: !!banner.isExternalLink
                    };
                });
            }

            return {
                hasBanners: processedBanners.length > 0,
                banners: processedBanners,
                navigation: this.carouselOptions.navigation && processedBanners.length > 1,
            };
        },

        /**
         * Initialize Swiper carousel after view is rendered
         */
        initSwiper: function initSwiper() {
            var swiperContainer = this.$(".ccawbannercarousel-swiper");

            if (typeof Swiper === "undefined") {
                console.log("Swiper is not available. Skipping carousel initialization.");
                return;
            }

            if (swiperContainer.length === 0 || !this.banners || this.banners.length === 0) {
                return;
            }

            var opts = this.carouselOptions;

            // Base Swiper config
            var swiperOptions = {
                slidesPerView: 1,
                loop: opts.loop,
                observer: true,
                observeParents: true,
                pauseOnMouseEnter: true,
                pagination: {
                    el: this.$(".swiper-pagination")[0],
                    clickable: true,
                    bulletActiveClass: "swiper-pagination-current",
                }
            };

            // Navigation arrows
            if (opts.navigation) {
                swiperOptions.navigation = {
                    prevEl: this.$(".ccawbannercarousel-nav-prev")[0],
                    nextEl: this.$(".ccawbannercarousel-nav-next")[0],
                };
            }

            // Autoplay
            if (opts.autoplay) {
                swiperOptions.autoplay = {
                    delay: opts.autoplayDelay,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                };
            }

            try {
                this.swiper = new Swiper(swiperContainer[0], swiperOptions);
            } catch (error) {
                console.error("Error initializing Swiper:", error);
            }
        },

        /**
         * Clean up Swiper on view destroy
         */
        destroy: function destroy() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
            Backbone.View.prototype.destroy.call(this);
        },
    });
});
